import { GetDeliveredEngagementSurveyQuery } from "types/graphql-schema";

import AssessmentLayout from "@apps/assessments/components/layouts/assessment-layout";
import { EngagementSurveyReportViewOptions } from "@apps/reporting/components/engagement-survey-report/types";
import Layout from "@components/layout/layout";
import Tooltip from "@components/tooltip/tooltip";
import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";

import EngagementSurveyDeliveryQuestionSections from "./engagement-survey-delivery-question-sections";

const EngagementSurveyDeliveryAllQuestions = ({
  assessmentDeliveryData,
  viewOptions,
}: {
  assessmentDeliveryData?: GetDeliveredEngagementSurveyQuery;
  viewOptions: EngagementSurveyReportViewOptions;
}) => {
  return assessmentDeliveryData?.assessmentDelivery?.answers.edges &&
    assessmentDeliveryData?.assessmentDelivery?.answers.edges.length > 0 ? (
    <AssessmentLayout.AssessmentTypeSection>
      <EngagementSurveyDeliveryQuestionSections
        assessmentDeliveryData={assessmentDeliveryData?.assessmentDelivery}
        viewOptions={viewOptions}
      />
    </AssessmentLayout.AssessmentTypeSection>
  ) : (
    <Layout.MainSubSectionEmpty>
      <div className="flex items-center justify-center gap-2.5 text-gray-400">
        <Tooltip text="To keep identities anonymous, we cannot display data when there are fewer than 3 people responding.">
          <span>
            <TopicflowIcon type="info" className="h-4 w-4" />
          </span>
        </Tooltip>
        <div className="text-sm">Not enough responses to show results</div>
      </div>
    </Layout.MainSubSectionEmpty>
  );
};

export default EngagementSurveyDeliveryAllQuestions;
